import { gql } from '__generated__'

export const GetUsersWithRosterAccess = gql(/* GraphQL */ `
    query GetUsersWithRosterAccess($rosterId: ID!) {
        roster(id: $rosterId) {
            sharedClients {
                client {
                    id
                    user {
                        id
                        firstName
                        lastName
                        email
                    }
                }
            }
            sharedRecruiters {
                recruiter {
                    id
                    userId
                    user {
                        id
                        firstName
                        lastName
                        email
                    }
                }
            }
        }
    }
`)

export const GetClientsWithPortalAccess = gql(/* GraphQL */ `
    query GetClientsWithPortalAccess($companyId: ID!) {
        getClientsWithPortalAccessForCompany(companyId: $companyId) {
            id
            user {
                id
                firstName
                lastName
                email
            }
        }
    }
`)

export const ShareRoster = gql(/* GraphQL */ `
    mutation ShareRoster(
        $rosterId: ID!
        $recruiterIds: [ID!]!
        $clientIds: [ID!]!
    ) {
        shareRoster(
            rosterId: $rosterId
            recruiterIds: $recruiterIds
            clientIds: $clientIds
        ) {
            success
            message
        }
    }
`)
